export const setBrowserTabTitle = (title, studyName) => {
  if (studyName) document.title = `${title} - ${studyName}`;
  else document.title = title;
};
